const loc = window.location.pathname;

// Showing the content after the css had been loaded
function enableView() {
  const body = document.querySelector('body');
  body.style.opacity = 1;
  body.style.backgroundColor = '#ecf0f5';
}

$(document).ready(() => {
  // Adding current class to links to the active page
  const links = document.querySelectorAll('.main-sidebar li a[href]');
  for (let i = 0; i < links.length; i += 1) {
    const href = (links[i].getAttribute('href'));
    if (href === loc) {
      links[i].parentElement.classList.add('current');
    }
  }
  enableView();
});

// Function that creates or modifies a cookie
function setCookie(name, val, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=${val};${expires};path=/;secure;samesite=strict`;
}

// Function that reads a cookie
function getCookie(name) {
  const value = `${name}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(value) === 0) {
      return c.substring(value.length, c.length);
    }
  }
  return '';
}

// Toggle switches
const switches = document.querySelectorAll('.switch');
if (switches) {
  for (let i = 0; i < switches.length; i += 1) {
    switches[i].addEventListener('change', (e) => {
      if (e.currentTarget.querySelector('input').hasAttribute('readonly')) {
        e.currentTarget.checked = !e.currentTarget.querySelector('input').checked;
      }
    });
  }
}
